<template lang="pug">
  div
    v-btn(small color='primary' :disabled="disabled" @click="toggle" outlined) Course language

    app-dialog(v-model="showing" title="Candidate language course" width="300")
      template(#dialog-body)
        .candidate-course-type__modal
          app-select(
            :options="languageCourseOptions"
            :value="selectedLanguageCourse"
            @input="selectedLanguageCourse = $event"
          )
      template(#dialog-footer)
        v-spacer
        app-button(color="#f4f4f4" hide-shadow @click.native="toggle").mr-2 Close
        app-button(color="primary" @click.native="$emit('select', {language_course: selectedLanguageCourse})") Save
</template>

<script>
import showingMixin from '@/mixins/showing.mixin'

export default {
  name: 'CandidateLanguageCource',

  props: {
    languageCourse: {type: String},
    disabled: {type: Boolean, default: false}
  },

  data: () => ({
    selectedLanguageCourse: '',
    languageCourseOptions: [
      'nl',
      'en'
    ]
  }),

  mixins: [showingMixin],

  components: {
    appDialog: () => import('@/components/global/actions/BaseDialog.vue'),
    appButton: () => import('@/components/global/actions/BaseButton.vue'),
    appSelect: () => import('@/components/global/actions/BaseSelect.vue')
  },

  watch: {
    showing(value) {
      if (!value) this.selectedLanguageCourse = ''
      else this.selectedLanguageCourse = this.languageCourse;
    }
  }
}
</script>

<style lang="scss">
.candidate-course-type__modal {
  padding: 10px 20px;
}
</style>



